import React from 'react';
import ResponsiveGallery from 'react-responsive-gallery';
import Typography from "@mui/material/Typography";
import gallery_1 from '../../assets/gallery_1.webp';
import gallery_2 from '../../assets/gallery_2.webp';
import gallery_3 from '../../assets/gallery_3.webp';
import gallery_4 from '../../assets/gallery_4.webp';
import gallery_5 from '../../assets/gallery_5.webp';
import gallery_6 from '../../assets/gallery_6.webp';
import gallery_7 from '../../assets/gallery_7.webp';
import gallery_8 from '../../assets/gallery_8.webp';

const Gallery = ()  => {
    const images = [gallery_1, gallery_2, gallery_3, gallery_4, gallery_5, gallery_6, gallery_7, gallery_8];

    return <div className='gallery' id='gallery'>
        <Typography variant="h3" sx={{color: "var(--primary-color)", fontSize: '30px', fontWeight: 'bold', marginY: '40px', textTransform: 'uppercase'}} className='section-title'>Galería</Typography>
        <div className='gallery-container'>
            <ResponsiveGallery
                useLightBox
                media={[
                    {
                        src: images[0],
                        alt: "vista a la montaña",
                        orderS: 1,
                        orderM: 1,
                        orderL: 1
                    },
                    {
                        src: images[1],
                        alt: "terreno llano con vista a la montaña",
                        orderS: 2,
                        orderM: 2,
                        orderL: 2
                    },
                    {
                        src: images[2],
                        alt: "terreno llano con vista a la montaña y a la ciudad de Constanza",
                        orderS: 4,
                        orderM: 3,
                        orderL: 6
                    },
                    {
                        src: images[3],
                        alt: "vista a la montaña desde punto alto del terreno",
                        orderS: 3,
                        orderM: 4,
                        orderL: 5
                    },
                    {
                        src: images[4],
                        alt: "senderismo en la montaña",
                        orderS: 5,
                        orderM: 6,
                        orderL: 4
                    },
                    {
                        src: images[5],
                        alt: "camino de senderismo con vista a la montaña",
                        orderS: 6,
                        orderM: 5,
                        orderL: 3
                    },
                    {
                        src: images[6],
                        alt: "mujer haciendo senderismo con vista a la montaña",
                        orderS: 7,
                        orderM: 7,
                        orderL: 7
                    },
                    {
                        src: images[7],
                        alt: "terreno llano con vista a la montaña",
                        orderS: 8,
                        orderM: 8,
                        orderL: 8
                    }
                ]}
             />
        </div>
    </div>
}
export default Gallery;
